<script setup lang="ts">
interface Props {
  text?: string
}
defineProps<Props>()
</script>

<template>
  <div
    class="flex items-center before:me-3 before:flex-1 before:border-t before:border-surface after:ms-3 after:flex-1 after:border-t after:border-surface"
  >
    <span
      v-if="text"
      class="rounded-full border px-4 py-1 text-sm font-bold"
    >
      {{ text }}
    </span>
    <slot />
  </div>
</template>
